import React, { useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

interface LogoProps {
  variant?: 'full' | 'icon';
  size?: 'small' | 'medium' | 'large';
}

const Logo: React.FC<LogoProps> = ({ variant = 'full', size = 'medium' }) => {
  const theme = useTheme();
  const [imageError, setImageError] = useState(false);
  
  const sizes = {
    small: { icon: 24, text: '1rem' },
    medium: { icon: 32, text: '1.25rem' },
    large: { icon: 40, text: '1.5rem' },
  };

  // Fallback component when image fails to load
  const FallbackIcon = () => (
    <Box 
      sx={{
        width: sizes[size].icon,
        height: sizes[size].icon,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: `${sizes[size].icon / 2}px`,
        fontWeight: 'bold'
      }}
    >
      $
    </Box>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        color: theme.palette.primary.main,
      }}
    >
      {imageError ? (
        <FallbackIcon />
      ) : (
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/img/superior-icon.svg`}
          alt="Superior Payroll Logo"
          sx={{
            width: sizes[size].icon,
            height: sizes[size].icon,
            objectFit: 'contain'
          }}
          onError={() => setImageError(true)}
        />
      )}
      
      {variant === 'full' && (
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: sizes[size].text,
            letterSpacing: '-0.025em',
          }}
        >
          Superior
        </Typography>
      )}
    </Box>
  );
};

export default Logo; 